export default function (zipcode) {
  return zipcode !== '-1' && zipcode !== -1;
}
